import React from 'react';
import { useLocation } from 'react-router-dom';
import './Success.css';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { jsPDF } from 'jspdf';
import { downloadVoucher } from "../utils/voucherGenerator";

const Success = () => {
   
    const location = useLocation();
    const { coupon, end_date, discount, voucher_name, voucher_wish, game, description, imageUrl } = location.state || {};
    const { t, i18n } = useTranslation();

    const handleDownload  = () =>{
        downloadVoucher({
            coupon: coupon,
            voucherName: voucher_name,
            voucherWish: voucher_wish,
            endDate: end_date,
            gameName: game,
            gameDescription: description,
            imageUrl: imageUrl,
            language: i18n.language
        });
    }
    return (
        <div className="success-container">
            <div className="success-message">
                <h2>{t('success.payment_successful')}</h2>
                <p>{t('success.congratulations')}</p>
            </div>
            {coupon && end_date && (
                <div className="coupon-details">
                    <h3>{t('success.coupon_details')}</h3>
                    <p><strong>{t('success.coupon_code')}:</strong> {coupon}</p>
                    <p><strong>{t('success.use_before')}:</strong> {formatEndDate(end_date)}</p>
                </div>
            )}
            {discount !== null && (
                <>
                    <p>{t('success.use_discount1')} {discount} % {t('success.use_discount2')}</p>
                    <p>
                        <Link to="/mygames" className="my-games-link">
                            {t('success.find_your_game')}
                        </Link>
                    </p>
                </>
            )}
            {voucher_name && (
                <button className="download-voucher" onClick={handleDownload }>
                    {t('success.download_voucher')}
                </button>
            )}
        </div>
    );
};

const formatEndDate = (endDate) => {
    const parsedDate = new Date(endDate);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Intl.DateTimeFormat('en-US', options).format(parsedDate);
};

export default Success;
